<template>
  <div class="card-box-overview overview-card p-5">
    <h3 v-if="!useSlot" class="mb-6">{{ title }}</h3>
    <slot v-else />
    <div>
      <div v-if="loading" class="text-center py-9">
        <b-spinner variant="primary" />
      </div>
      <div
        v-else
        v-for="(item, index) in options"
        :key="`card-info-${index}`"
        class="value-card"
      >
        <small class="text-secondary">{{ item.name }}</small>
        <div class="d-flex align-items-center">
          <h6
            :class="
              `${item.class} ${hideValues && item.blur ? 'blur' : ''} mr-2`
            "
          >
            {{ item.value }}
          </h6>
          <div v-if="item.rightInfo" :class="`${item.rightInfo.class} pb-2`">
            <i v-if="item.rightInfo.icon" :class="`${item.rightInfo.icon}`" />
            <small :class="`${hideValues && item.blur ? 'blur' : ''} mr-2`">
              {{ item.rightInfo.value }}
            </small>
          </div>
        </div>
        <small
          v-if="item.secondaryValue"
          :class="`${item.class} ${hideValues && item.blur ? 'blur' : ''}`"
        >
          {{ item.secondaryValue }}
        </small>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    externalLoading: {
      type: Boolean,
      default: false
    },
    useSlot: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    hideValues: Boolean
  },
  data() {
    return {
      loading: false
    };
  },
  watch: {
    externalLoading(val) {
      this.loading = val;
    }
  }
};
</script>
<style lang="scss" scoped>
.card-box-overview {
  height: 100%;
  .value-card {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:not(:last-child),
    &:not(:first-child) {
      margin: 8px 0;
    }
  }

  button {
    min-height: 9px;
    i {
      font-size: 10px;
      color: #928f98;

      @media screen and (max-width: 991px) {
        font-size: 14px;
      }
    }
  }

  .blur {
    will-change: filter;
    filter: blur(0.4rem);
  }
}
</style>
